export default __webpack_public_path__ + "static/media/project-placeholder.a30076fe.svg";